import React, {useState} from 'react';
import Table from "../../common/table/table";
import LocationsTable from "./LocationsTable";
import MessageEmptyData from "../../common/messageEmptyData";
import ModalConfirmation from "../../common/modal/ModalConfirmation";
import apiClient from "../../../utils/apiClient";
import {removeObjFromArray} from "../../../utils/arrayHelpers";
import {toast} from "react-toastify";

/**
 * LocationsBody component
 * @param prop
 * @returns {JSX.Element|null}
 * @constructor
 */
const LocationsBody = (prop) => {
    const {filters, tableData, setTableData} = prop;
    const [selectedRow, setSelectedRow] = useState({});
    const [approveModal, setApproveModal] = useState({isOpen: false, message: <p></p>});
    const [disapproveModal, setDisapproveModal] = useState({isOpen: false, message: <p></p>});

    const ApproveHandler = () => {
        apiClient
            .post('reactivateLocation', {'id': selectedRow.id})
            .then(response => {
                const newTableData = removeObjFromArray(tableData, "id", response.data.id);
                setTableData(newTableData);
                toast.success(response.data.message);
            })
            .then(function () {
                setApproveModal({...approveModal, isOpen: false})
            });
    }

    const DisapproveHandler = () => {
        apiClient
            .post('deactivateLocation', {'id': selectedRow.id})
            .then(response => {
                const newTableData = removeObjFromArray(tableData, "id", response.data.id);
                setTableData(newTableData);
                toast.success(response.data.message);
            })
            .then(function () {
                setDisapproveModal({...disapproveModal, isOpen: false})
            });
    }

    if (!filters.isSubmitted) {
        return null;
    }

    if (tableData.length === 0) {
        return <MessageEmptyData/>;
    }

    return (
        <div className="container-fluid">
            <Table
                columns={
                    LocationsTable(
                        setSelectedRow, setApproveModal, setDisapproveModal
                    )
                }
                data={tableData}
                exportOptions={{pdf: false, xlsx: true, csv: true}}
                getExportFileName={() => 'locations'}
                withGlobalSearch={true}
                scrollable={true}
            />
            <ModalConfirmation
                modal={approveModal}
                setModal={setApproveModal}
                title="Reactivate Location"
                onConfirm={ApproveHandler}
            />
            <ModalConfirmation
                modal={disapproveModal}
                setModal={setDisapproveModal}
                title="Deactivate Location"
                onConfirm={DisapproveHandler}
            />
        </div>
    );
}

export default LocationsBody;
